export default "__VITE_ASSET__DGvxXCCF__"